import * as React from 'react';
import { cn } from '@/lib/utils';
import { Link } from 'react-router-dom';
import { FiMenu } from 'react-icons/fi';

const DashboardSidebarWrapper = React.forwardRef(({ className, viewMode, ...props }, ref) => {
  return (
    <aside
      ref={ref}
      className={cn(
        'c-dashboard-sidebar-wrapper',
        // Mobile
        'fixed left-0 right-0 top-0 z-[105] md:left-[64px]',
        // Desktop (md)
        'md:bottom-0 md:right-auto md:z-[103] md:w-[260px]',
        // Estilização
        'bg-fixed',
        // Shadow Inset Customizado
        'shadow-[inset_-5px_-5px_20px_rgba(188,196,214,0.2)]',
        viewMode === 'create' && 'md:left-0',
        className
      )}
      style={{
        // Gradiente específico conforme o CSS original
        background: 'linear-gradient(140deg, #FFFFFF -30%, var(--color-primary-lightest) 100%)'
      }}
      {...props}
    />
  );
});
DashboardSidebarWrapper.displayName = 'DashboardSidebarWrapper';

const DashboardSidebarContent = React.forwardRef(({ className, isActive = false, viewMode, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        'c-dashboard-sidebar-content',
        // Base Mobile
        'fixed left-0 right-0 top-[46px] z-10 box-border h-[100vh] overflow-y-auto overflow-x-hidden p-[1em] transition-all duration-200 ease-in-out',
        'pointer-events-none -mt-[10px] opacity-0',
        // Desktop (md)
        'md:pointer-events-auto md:bottom-0 md:left-[64px] md:top-0 md:mt-0 md:flex md:w-[260px] md:flex-col md:p-[44px_22px] md:opacity-100',
        viewMode === 'create' && 'md:left-0',
        // Estado Ativo - Geralmente disparado no mobile
        isActive && [
          // Mobile Ativo
          'pointer-events-auto mt-0 opacity-100',
          'bg-[linear-gradient(180.71deg,#FFFFFF_-30%,#F2FAFE_80%)]',
          'shadow-[0_15px_15px_rgba(var(--color-primary-dark),0.1)]',
          'max-height-[calc(100vh-46px)] overflow-y-auto'
        ],
        className
      )}
      {...props}
    />
  );
});
DashboardSidebarContent.displayName = 'DashboardSidebarContent';

const DashboardSidebarMobile = React.forwardRef(({ className, children, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        'c-dashboard-sidebar-mobile',
        // styles
        'flex flex-wrap items-center justify-between border-b border-solid border-primary-lightest bg-bright p-4 pb-2 pr-6',
        'md:hidden',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
});
DashboardSidebarMobile.displayName = 'DashboardSidebarMobile';

const DashboardSidebarLogo = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <Link
      ref={ref}
      className={cn(
        'c-dashboard-sidebar-logo',
        // styles
        'mb-[3em] hidden max-w-[170px] cursor-pointer',
        'md:block',
        className
      )}
      {...props}
    />
  );
});
DashboardSidebarLogo.displayName = 'DashboardSidebarLogo';

const DashboardSidebar = React.forwardRef(({ children, hasBrand = true, viewMode, ...props }, ref) => {
  const [active, setActive] = React.useState(false);

  const mobileNavToggle = () => {
    setActive(!active);
  };

  const appName = process.env.REACT_APP_NAME;

  const Logo = appName === 'canaleducacao' || appName === 'maiseducacao' ? require(`@/assets/images/${appName}/logo-seduc-horizontal.png`) : require(`@/assets/images/${appName}/horizontal-logo.svg`);

  return (
    <DashboardSidebarWrapper
      ref={ref}
      viewMode={viewMode}
      {...props}
    >
      <DashboardSidebarMobile>
        <Link to="/">
          <img
            src={Logo}
            className="h-5 w-auto cursor-pointer"
          />
        </Link>

        <div onClick={mobileNavToggle}>
          <FiMenu
            size={16}
            className="text-primary"
          />
        </div>
      </DashboardSidebarMobile>

      <DashboardSidebarContent
        isActive={active}
        viewMode={viewMode}
      >
        {hasBrand && (
          <DashboardSidebarLogo to="/">
            <img src={Logo} />
          </DashboardSidebarLogo>
        )}

        {children}
      </DashboardSidebarContent>
    </DashboardSidebarWrapper>
  );
});
DashboardSidebar.displayName = 'DashboardSidebar';

export { DashboardSidebar };
